
import { ApiURLs } from "../../../constant/ApiUrls";
import { fetchData, postData, updateData, } from "../../../services/api";
import { hideAddPaymentOptionModal } from "./paymentOptionModalDispatcher";



export const adPaymentOptionRequest = (data,) => {
  return async (dispatch) => {
    dispatch({ "type": "ADD_PAYMENT_OPTION_REQUEST" });
    try {

      var gdprResponse = (data.id) ? await updateData(data, `${ApiURLs.GDPR}/${data.id}`) : await postData(data, ApiURLs.GDPR,false);
      if (gdprResponse.status === 1) {
        dispatch({ "type": "ADD_PAYMENT_OPTION_SUCCESS" });
        dispatch(hideAddPaymentOptionModal());
        dispatch(paymentOptionLisitingRequest(data.gdpr_key));
      } else {
        dispatch({ "type": "ADD_PAYMENT_OPTION_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "ADD_PAYMENT_OPTION_FAILED" });

    }
  };
};




export const paymentOptionLisitingRequest = (gdpr_key="payment-option") => {

  return async (dispatch) => {

    const url = `${ApiURLs.GDPR}?gdpr_key=${gdpr_key}`;

    console.log("GDPR:::",url);
    // wait untill the data not received so getData function take data and url part
    dispatch({ "type": "GET_PAYMENT_OPTION_REQUEST" });
    try {
      var gdprData = await fetchData(url);
      console.log(`response when we try to get terms  ${JSON.stringify(gdprData)}`)
      if (gdprData.status === 1) {
        dispatch({ type: "GET_PAYMENT_OPTION_REQUEST_SUCCESS", payload: gdprData.data.result });

      } else {
        dispatch({ "type": "GET_PAYMENT_OPTION_REQUEST_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "GET_PAYMENT_OPTION_REQUEST_FAILED" });
      console.log(`error while try to get payment option  ${error}`)
    }
  }
};



